<template>
  <div>
    <b-container fluid>
      <title>Clone Approved of HRM Requests</title>
      <h1>Clone Approved of HRM Requests</h1>

       <b-row>
          <b-col cols="12" lg="4">
            <BaseTextInput v-model="criteria.approvedRequestId" 
              :v="$v.criteria.approvedRequestId"
              label="MDH Tracking ID"
              tip=""
              slug="requestId"/>
          </b-col>
          <b-col cols="12" lg="4">
            <BaseTextInput v-model="criteria.batchSize" 
              :v="$v.criteria.batchSize"
              label="Number of Clones"
              tip=""
              slug="requestId"/>
          </b-col>
      </b-row>
      <b-row>
          <b-col>
              <b-button type="button" variant="primary" @click="submit">
                  <b-spinner small v-show="loading" class="mr-2"></b-spinner>
                  Submit
              </b-button>
          </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import axios from 'axios';
  import axiosRetry from 'axios-retry';
  import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf, ref, minValue, maxValue } from 'vuelidate/lib/validators'

  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

  export default {
    data: () => ({
      loading: false, 
      criteria: {
        approvedRequestId: null, 
        batchSize: null,
      },
    }),

    validations() {
        return {
          criteria: {
            approvedRequestId: {
              required,
            },
            batchSize: {
              required,
              numeric,
            },
          }
        }
    },

    methods: {
      submit () {
        this.loading = true
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/batch/approval`, this.criteria)
        .then(response => {
          this.loading = false
            this.$bvToast.toast('HRM Requests Cloned', {
              title: 'Status',
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: 'success',
              appendToast: true
            });
        });          
      }
    }
  }
</script>